// extracted by mini-css-extract-plugin
export default {"container":"Details_container__KjJCc","form":"Details_form__qInzA"};